import { tProvidersProps } from '../LayoutProvider/Layout.types';
import { AlertCenterContext } from './AlertCenter.context';
import { useAlertCenterValue } from './AlertCenter.hook';

/**
 * Alert Center — the single owner of "which alerts are live right now".
 *
 * It assembles one `tAlertSnapshot` from the contexts the existing banners
 * read individually, hands it to the pure `selectAlerts`, and exposes the
 * result plus the acknowledge and inline-visibility seams. The banners
 * themselves keep working unchanged until U3 moves them; this provider adds
 * no rendering.
 *
 * Placement (verified against the real nesting in `Providers.component`):
 * inside `WhatsappApiProvider` — it reads `useWhatsappApiContext` for account
 * health — and inside `IntercomProvider`, whose `showNewMessage` is how the
 * `intercom` CTA kind is carried out. Everything else it reads (ACL,
 * Subscription, Workspace, User, Sockets, LeadAgentAcceptance, Integrations,
 * Team) already sits above that point, and it stays above `LayoutProvider` so
 * every private surface can consume it.
 *
 * NOT to be confused with `NotificationsProvider`, which owns agenda toasts.
 */
export default function AlertCenterProvider(props: tProvidersProps) {
  const value = useAlertCenterValue();

  return (
    <AlertCenterContext.Provider value={value}>
      {props.children}
    </AlertCenterContext.Provider>
  );
}
